import { render, staticRenderFns } from "./control_direccion_envio.vue?vue&type=template&id=263fc0ea"
import script from "./control_direccion_envio.vue?vue&type=script&lang=js"
export * from "./control_direccion_envio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports